const formatDate = (date) => {
    if (date && date.includes("-")) {
        const dateParts = date.split("-");
        if (dateParts.length === 3) {
            const formattedDate = `${dateParts[1]}/${dateParts[2]}/${dateParts[0]}`;
            return formattedDate;
        }
    }
    return date;
}

export default formatDate;